import axios from "../../axiosConfig";

export const uploadBlobFile = async ({ 
    departmentsFolder, departmentFolder, containerName, token, item, fileTypeId, userEmail, formData }) => {
  if (!token || !formData) throw new Error("Missing token");

  const saveUrl = `/upload/blob?&departmentsFolder=${encodeURIComponent(departmentsFolder)}&departmentFolder=${encodeURIComponent(departmentFolder)}&orderNumFolder=${encodeURIComponent(item.so)}&containerName=${encodeURIComponent(containerName)}&orderFileNotes=${encodeURIComponent('')}&orderDetailId=${encodeURIComponent(item.orderDetailId)}&fileTypeId=${encodeURIComponent(fileTypeId)}&author=${encodeURIComponent(userEmail)}`;

  const response = await axios.post(saveUrl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token,
    }
  });

  return response.data;
};

export const deleteBlobFile = async ({ 
    fileName, departmentsFolder, departmentFolder, containerName, token, item, userEmail }) => {
  if (!token) throw new Error("Missing token");

  const deleteUrl = `/delete/blob?&fileName=${encodeURIComponent(fileName.name)}&departmentsFolder=${encodeURIComponent(departmentsFolder)}&departmentFolder=${encodeURIComponent(departmentFolder)}&orderNumFolder=${encodeURIComponent(item.so)}&containerName=${encodeURIComponent(containerName)}&orderDetailId=${encodeURIComponent(item.orderDetailId)}&author=${encodeURIComponent(userEmail)}`;
  const response = await axios.delete(deleteUrl, {
    headers: {
      Authorization: token,
    },
  });    


  return response.data;
};